import React, { CSSProperties, ReactNode, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import Div100vh from 'react-div-100vh';
import Login from './screens/Login/Login';
import Home from './screens/Home';
import Races from './screens/Races';
import RacesReorder from './screens/RacesReorder';
import CandidateDetail from './screens/CandidateDetail';
import Elections from './screens/Elections';
import RaceDetail from './screens/RaceDetail';
import { useDispatch, useSelector } from 'react-redux';
import { userLogin, userLogout } from './app/actions';
import styled, { ThemeProvider } from 'styled-components';
import { adaptV4Theme, createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { FeathersProvider, isPermitted, taskConfigurations } from './app/util';
import Offices from './screens/Offices';
import OfficeDetail from './screens/OfficeDetail';
import Issues from './screens/Issues';
import Measures from './screens/Measures';
import MeasureDetail from './screens/MeasureDetail';
import Translations from './screens/Translations';
import ElectionDetail from './screens/ElectionDetail';
import DistrictIcon from '@mui/icons-material/Public';
import AcceptInvite from './screens/AcceptInvite';
import ResearcherAnalytics from './screens/ResearcherAnalytics';
import Team from './screens/Team';
import TaskList from './screens/TaskList';
import ElectionCoveragePlan from './screens/ElectionCoveragePlan';
import ElectionProgress from './screens/ElectionProgress';
import ElectionGeodistricts from './screens/ElectionGeodistricts';
import SetupElection from './screens/SetupElection';
import ScoutBallotItems from './screens/ScoutBallotItems';
import FeedbackDetail from './screens/FeedbackDetail';
import UploadCandidateList from './screens/UploadCandidateList';
import CandidateLists from './screens/CandidateLists';
import AutoScouters from './screens/AutoScouters';
import AutoScouterDetail from './screens/AutoScouterDetail';
import ResearcherAnalyticsIndividual from './screens/ResearcherAnalyticsIndividual';
import AnalyticsIcon from '@mui/icons-material/Timeline';
import ReportedErrorList from './screens/ReportedErrorList';
import ReportedErrorDetail from './screens/ReportedErrorDetail';
import { Build as BuildIcon, Flag as FlagIcon } from '@mui/icons-material';
import StateConfig from './screens/StateConfig';
import Edits from './screens/Edits';
import MeasureLists from './screens/MeasureLists';
import UploadMeasureList from './screens/UploadMeasureList';
import ElectionMigrationRunDetail from './screens/ElectionMigrationRunDetail';
import ContestShapefiles from './screens/ContestShapefiles';
import ContestShapefileDetail from './screens/ContestShapefileDetail';

import NavigationPane from './screens/NavigationPane';
import MenuItem from './screens/NavigationPane/MenuItem';
import { ReactComponent as RacesIcon } from './images/races-icon.svg';
import { ReactComponent as ElectionsIcon } from './images/elections-icon.svg';
import { ReactComponent as MeasuresIcon } from './images/legal-contract-paper.svg';
import { ReactComponent as DataLink } from './images/cluster-data.svg';
import GavelIcon from '@mui/icons-material/Gavel';
import TaskListIcon from '@mui/icons-material/List';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
    
import rest from '@feathersjs/rest-client';
import superagent from 'superagent';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import HomeIcon from '@mui/icons-material/Home';
import ElectionDates from './screens/ElectionDates';
import States from './screens/States';
import StateDetail from './screens/StateDetail';
import Tier2DistrictType from './screens/Tier2DistrictType';
import Tier2DistrictDetail from './screens/Tier2DistrictDetail';
import feathers, { Application } from '@feathersjs/feathers';
import feathersAuth from '@feathersjs/authentication-client';
import { ServiceTypes } from './app/feathers/ServiceTypes';
import './app/feathers/Application';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import AssessmentIcon from '@mui/icons-material/Assessment';
import Reports from './screens/Reports';
import Profile from './screens/Profile';

const taskTypes = Object.keys(taskConfigurations);
const defaultPrivateRoutePermissions = [
  'super-admin',
  'find-website',
  'editor',
  'user-management',
  'researcher',
  'reviewer',
  'publisher',
  'auditor',
  'translations',
];
const contestShapefileRoutePermissions = [
  ...defaultPrivateRoutePermissions,
  'dms-shapefile',
];

const theme = {
  font: {
    normal: `font-family: HouschkaRoundedAlt; font-weight: normal;`,
    bold: `font-family: HouschkaRoundedAlt; font-weight: bold;`,
  },
  colors: {
    darkPurple: '#22034F',
    indigo: '#453DB7',
    lightPurple: '#B4B3F8',
    lightBlue: '#94ACF9',
    subtleGrey: '#878787',
    darkGrey: '#313639',
    honeyYellow: '#EFF1B6',
  },
  palette: {
    primary: '#22034F',
    accent: '#453DB7',
  },
};

const muiTheme = createTheme(adaptV4Theme({
  palette: {
    primary: {
      main: '#22034F',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#453DB7',
      contrastText: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"HouschkaRoundedAlt"',
    h1: {
      fontSize: '28px',
      fontWeight: 'bold',
    },
    h2: {
      fontSize: '24px',
      fontWeight: 'bold',
    },
    h3: {
      fontSize: '20px',
      fontWeight: 'bold',
    },
    h4: {
      fontSize: '18px',
      fontWeight: 'bold',
    },
    h5: {
      fontSize: '14px',
      opacity: 0.7,
      fontWeight: 'bold',
    },
    button: {
      fontSize: '0.95rem',
      fontWeight: 700,
      textTransform: 'none',
    },
  },
  overrides: {
    MuiTextField: {
      root: {
        // backgroundColor: '#FFFFFF',
        backgroundColor: 'transparent',
      },
    },
    MuiSelect: {
      root: {
        backgroundColor: '#FFFFFF',
        
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
        fontSize: '0.95rem',
        letterSpacing: '0.5px',
        fontWeight: 700,
      },
      contained: {
        '& > span': {
          color: '#FFFFFF',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: '#FFFFFF',
      },
      notchedOutline: {
        borderColor: '#D3D3D3',
      },
    },
  },

}));

interface FixMeState {
  user: {
    permissions: string[]
    loggedIn: boolean;
  };
}

const App = () => {
  const dispatch = useDispatch();
  const { loggedIn, permissions } = useSelector((state: FixMeState) => state.user);
  const [feathersClient, setFeathersClient] = React.useState(null as unknown as Application);
  const userManagementPermission = permissions?.some(permission => ['super-admin', 'editor', 'user-management'].includes(permission));
  const resolveErrorPermission = permissions?.some(permission => ['super-admin', 'editor', 'admin', 'resolve-error'].includes(permission));
  const dataLinkPermissions = (permissions || []).some(p => ['admin', 'super-admin', 'reviewer', 'editor', 'publisher'].includes(p));
  const editorPermission = (permissions || []).some(p => ['admin', 'super-admin', 'editor'].includes(p));
  const reportsPermission = (permissions || []).some(p => ['super-admin', 'editor'].includes(p));
  const homePermissions = (permissions || []).some(p => ['admin', 'super-admin', 'editor', 'publisher', 'reviewer', 'researcher', 'translations'].includes(p));
  const didInit = useRef(false);

  const researchPortalPermissions = permissions?.some(p => [
    'super-admin',
    'editor',
    'user-management',
    'publisher',
    'reviewer',
    'researcher',
    'auditor',
    'translations',
    'dms-shapefile',
  ].includes(p));

  const loadFeathers = async () => {
    const app = feathers<ServiceTypes>();
    app.getService = function(name: string) {
      return app.service(`api/v1/${name}`);
    };

    const endpoint = (process.env.NODE_ENV === 'development')
      ? 'http://localhost:3030'
      : 'https://www.branch.vote';
    const restClient = rest(endpoint);
    app.configure(restClient.superagent(superagent));

    // Pass the custom authentication client class as the `Authentication` option
    app.configure(feathersAuth({
      storageKey: 'auth-data-editor',
      path: '/api/v1/authentication',
    }));
    app.getService('finances').timeout = 15000;
    app.getService('races').timeout = 15000;
    app.getService('elections').timeout = 30000;
    app.getService('election-results').timeout = 30000;
    app.getService('research-tasks').timeout = 40000;
    app.getService('candidates').timeout = 40000;
    app.getService('auto-scouter').timeout = 60000;
    app.getService('shapefiles').timeout = 60000;
    app.getService('districts').timeout = 60000;
    app.getService('naming-patterns').timeout = 60000;
    app.getService('geo-districts').timeout = 120000;
    app.getService('contest-shapefiles').timeout = 120000;

    if (loggedIn) {
      try {
        const result = await app.reAuthenticate();
        dispatch(userLogin(result.user));
      } catch (err) {
        dispatch(userLogout());
      }
    } else {
      dispatch(userLogout());
    }

    setFeathersClient(app);    
  };

  useEffect(() => {
    if (didInit.current) return;
    didInit.current = true;
    loadFeathers();
  }, [feathers]);


  const styles: CSSProperties = {
    position: 'absolute',
    width: '100vw',
    minHeight: '100rvh',
    maxHeight: '100rvh',
    overflowY: 'visible',
    overflowX: 'hidden',
    background: '#F7F9FE',
  };

  return (
    <Div100vh style={styles}>
      <ThemeProvider theme={theme}>
        <MUIThemeProvider theme={muiTheme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <FeathersProvider value={feathersClient}>
              <Router>
                <AppBody>
                  {loggedIn && researchPortalPermissions && (
                    <NavigationPane toHome={{ to: '/elections' }}>
                      {
                        homePermissions &&
                        <MenuItem
                          onClick={{ to: `/home` }}
                          text="Home"
                          icon={<HomeIcon style={{ color: '#FFFFFF', width: '24px', height: '24px' }} />}
                          matchRoutes={['/home']}
                        />
                      }
                      <MenuItem
                        onClick={{ to: '/elections' }}
                        text="Elections"
                        icon={<ElectionsIcon />}
                        matchRoutes={['/elections', '/elections/new', '/elections/.*']}
                        renderChildrenIf={(route: string) => (
                          route.startsWith('/elections/') && route !== '/elections/new'
                        )}
                        modifyChildrenOnClick={(onClick, routeParams) => (
                          (onClick?.to && routeParams?.key)
                            ? { to: onClick.to.replace('SELECTED_ELECTION', routeParams.key) }
                            : onClick
                        )}
                      >
                        <MenuItem
                          onClick={{ to: `/elections/SELECTED_ELECTION/races` }}
                          text="Races"
                          icon={<RacesIcon />}
                          matchRoutes={[
                            '/elections/.*/races/new',
                            '/elections/.*/races/.*/candidates/.*',
                            '/elections/.*/races/.*',
                            '/elections/.*/races',
                          ]}
                        />
                        <MenuItem
                          onClick={{ to: `/elections/SELECTED_ELECTION/measures` }}
                          text="Referendums"
                          icon={<MeasuresIcon />}
                          matchRoutes={[
                            '/elections/.*/measures/new',
                            '/elections/.*/measures/.*',
                            '/elections/.*/measures',
                          ]}
                        />
                      </MenuItem>
                      <MenuItem
                        onClick={{ to: `/offices` }}
                        text="Offices"
                        icon={<GavelIcon style={{ color: '#FFFFFF' }} />}
                        matchRoutes={['/offices', '/offices/.*']}
                      />
                      <MenuItem
                        onClick={{ to: `/states` }}
                        text="Districts"
                        icon={<DistrictIcon style={{ color: '#FFFFFF' }} />}
                        matchRoutes={['/states', '/states/.*']}
                      />
                      {resolveErrorPermission && (
                        <MenuItem
                          onClick={{ to: `/reported-errors` }}
                          text="Errors"
                          icon={<BuildIcon style={{ color: '#FFFFFF' }} />}
                          matchRoutes={['/reported-errors', '/reported-errors/.*']}
                        />
                      )}
                      {resolveErrorPermission && (
                        <MenuItem
                          onClick={{ to: `/edits` }}
                          text="Edits"
                          icon={<FlagIcon style={{ color: '#FFFFFF' }} />}
                          matchRoutes={['/edits']}
                        />
                      )}
                      {
                        editorPermission && (
                          <MenuItem
                            onClick={{ to: `/tasks-list` }}
                            text="Tasks"
                            icon={<TaskListIcon style={{ color: '#FFFFFF' }} />}
                            matchRoutes={['/tasks-list']}
                          />
                        )
                      }
                      {
                        reportsPermission && (
                          <MenuItem
                            onClick={{ to: `/reports` }}
                            text="Reports"
                            icon={<AssessmentIcon style={{ color: '#FFFFFF' }} />}
                            matchRoutes={['/reports']}
                          />
                        )}
                      {userManagementPermission && (
                        <MenuItem
                          onClick={{ to: `/team` }}
                          text="Team"
                          icon={<SupervisorAccountIcon style={{ color: '#FFFFFF' }} />}
                          matchRoutes={['/team', '/team/analytics']}
                          renderChildrenIf={(route: string) => (
                            route.startsWith('/team')
                          )}
                        >
                          <MenuItem
                            onClick={{ to: `/team/analytics` }}
                            text="Analytics"
                            icon={<AnalyticsIcon style={{ color: '#FFFFFF' }} />}
                            matchRoutes={[
                              '/team/analytics',
                            ]}
                          />
                        </MenuItem>
                      )}
                    </NavigationPane>
                  )}
                  <div
                    style={{
                      flex: 1,
                      height: '100vh',
                      overflowY: 'scroll',
                      position: 'relative',
                    }}
                  >
                    <Switch>
                      <PrivateRoute path="/tasks-list">
                        <TaskList />
                      </PrivateRoute>
                      <PrivateRoute path="/reports" permissions={['super-admin', 'editor']}>
                        <Reports />
                      </PrivateRoute>
                      {
                        taskTypes.map((taskType) => (
                          <PrivateRoute key={taskType} path={`/tasks/${taskType}`}>
                            {(taskConfigurations as Record<string, { taskPage: () => ReactNode }>)[taskType].taskPage()}
                          </PrivateRoute>
                        ))
                      }
                      <PrivateRoute path="/elections/:key/measures/:measureId/feedback/:feedbackId">
                        <FeedbackDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/measures/new">
                        <Measures />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/measures/:id">
                        <MeasureDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/dates">
                        <ElectionDates />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/measures">
                        <Measures />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/coverage-plan">
                        <ElectionCoveragePlan />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/progress">
                        <ElectionProgress />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/geodistricts">
                        <ElectionGeodistricts />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/scout-ballots/:districtId">
                        <ScoutBallotItems />
                      </PrivateRoute>
                      <PrivateRoute path="/reported-errors/:id">
                        <ReportedErrorDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/reported-errors">
                        <ReportedErrorList />
                      </PrivateRoute>
                      <PrivateRoute path="/states/:matchName/state-config">
                        <StateConfig />
                      </PrivateRoute>
                      <PrivateRoute path="/states/:matchName/:tier2Type/:tier2MatchOrId">
                        <Tier2DistrictDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/states/:matchName/:tier2Type">
                        <Tier2DistrictType />
                      </PrivateRoute>
                      <PrivateRoute path="/states/:matchName">
                        <StateDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/states">
                        <States />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/races/new">
                        <Races />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/candidate-lists/:id/:stepName?">
                        <UploadCandidateList />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/measure-lists/:id/:stepName?">
                        <UploadMeasureList />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/candidate-lists">
                        <CandidateLists />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/measure-lists">
                        <MeasureLists />
                      </PrivateRoute>
                      <PrivateRoute
                        path="/elections/:key/contest-shapefiles/:id/:stepName?"
                        permissions={contestShapefileRoutePermissions}
                      >
                        <ContestShapefileDetail />
                      </PrivateRoute>
                      <PrivateRoute
                        path="/elections/:key/contest-shapefiles"
                        permissions={contestShapefileRoutePermissions}
                      >
                        <ContestShapefiles />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/auto-scouters/:id/:stepName?">
                        <AutoScouterDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/auto-scouters">
                        <AutoScouters />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/races/:id/candidates/new">
                        <RaceDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/races/:raceId/candidates/:id/feedback/:feedbackId">
                        <FeedbackDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/races/:raceid/candidates/:id">
                        <CandidateDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/races/reorder">
                        <RacesReorder />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/races/:id">
                        <RaceDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/election-migration/:runId">
                        <ElectionMigrationRunDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/election-migration">
                        <ElectionMigrationRunDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/races">
                        <Races />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/new">
                        <Elections />
                      </PrivateRoute>
                      <PrivateRoute path="/elections/:key/setup">
                        <SetupElection />
                      </PrivateRoute>
                      <PrivateRoute
                        path="/elections/:key"
                        permissions={contestShapefileRoutePermissions}
                      >
                        <ElectionDetail />
                      </PrivateRoute>
                      <PrivateRoute
                        path="/elections"
                        permissions={contestShapefileRoutePermissions}
                      >
                        <Elections />
                      </PrivateRoute>
                      <PrivateRoute path="/offices/issues" permissions={['super-admin', 'editor']}>
                        <Issues />
                      </PrivateRoute>
                      <PrivateRoute path="/offices/:key">
                        <OfficeDetail />
                      </PrivateRoute>
                      <PrivateRoute path="/offices">
                        <Offices />
                      </PrivateRoute>
                      <PrivateRoute path="/translations">
                        <Translations />
                      </PrivateRoute>
                      <PrivateRoute path="/team/analytics/:userId">
                        <ResearcherAnalyticsIndividual />
                      </PrivateRoute>
                      <PrivateRoute path="/team/analytics">
                        <ResearcherAnalytics />
                      </PrivateRoute>
                      <PrivateRoute path="/team">
                        <Team />
                      </PrivateRoute>
                      <PrivateRoute path="/user-management">
                        <Redirect to="/team" />
                      </PrivateRoute>
                      <PrivateRoute path="/edits">
                        <Edits />
                      </PrivateRoute>
                      <Route path="/acceptInvite">
                        <AcceptInvite />
                      </Route>
                      <PrivateRoute path="/home">
                        <Home />
                      </PrivateRoute>
                      <PrivateRoute path="/profile">
                        <Profile />
                      </PrivateRoute>
                      <Route path="/">
                        <Login />
                      </Route>
                      <Route path="/logout">
                        <Login />
                      </Route>
                    </Switch>
                  </div>
                </AppBody>
              </Router>
            </FeathersProvider>
          </LocalizationProvider>
        </MUIThemeProvider>
      </ThemeProvider>
    </Div100vh>
  );
};

const AppBody = styled.div`
  position: absolute;
  width: 100vw;
  bottom: 0;
  margin: 0;
  top: 0px;
  display: flex;
  flex-direction: row;
`;

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
const PrivateRoute = ({
                        children,
                        permissions = defaultPrivateRoutePermissions,
                        ...rest
                      }: {
  children: ReactNode,
  permissions?: string[],
  path?: string,
}) => {
  const user = useSelector((state: FixMeState) => state.user);
  const { loggedIn } = user;
  const authenticated = loggedIn && isPermitted(user, permissions);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        authenticated ? (
          children
        ) : (
          <Redirect
            to={{
              // If trying to access a page with improper permissions,
              // redirect to dashboard. If trying to access a page without being
              // logged in, redirect to login.
              pathname: loggedIn && user.permissions?.length ? '/home' : '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default App;
